import { INSIGHTS_LENS_SLUGS } from "../constants/default-insights-lens";

type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * Get the label for an insights lens.
 * @param t - The translate function.
 * @param slug - The slug of the insights lens.
 * @returns The label for the insights lens.
 */
export const getInsightsLensLabel = (t: Translate, slug: string): string =>
  t(`generalPreferences.insightsLens.${slug}`, { ns: "dashboard" });

/**
 * Get the options for the insights lens select.
 * @param t - The translate function.
 * @returns The options for the insights lens select.
 */
export const getInsightsLensOptions = (t: Translate) =>
  INSIGHTS_LENS_SLUGS.map((slug) => ({
    value: slug,
    label: getInsightsLensLabel(t, slug),
  }));
